/**
 * Routes whose phase hasn't been built yet.
 *
 * §13.1's quality floor says "no unstyled or dead-end state reachable". A route
 * in the sidebar that 404s is a dead end; one that says what it will be, and
 * when, is not. These get replaced wholesale by their phases.
 */

import { ArrowLeftRight, Coins } from "lucide-react";
import { Link } from "react-router-dom";

import { Button, EmptyState, Panel } from "@/components/ui/primitives";

function Placeholder({
  icon,
  title,
  body,
}: {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  body: string;
}) {
  return (
    <div className="mx-auto max-w-4xl">
      <Panel>
        <EmptyState
          icon={icon}
          title={title}
          body={body}
          action={
            <Button asChild variant="default" size="sm">
              <Link to="/cards">Add a card meanwhile</Link>
            </Button>
          }
        />
      </Panel>
    </div>
  );
}

export const TransactionsPage = () => (
  <Placeholder
    icon={ArrowLeftRight}
    title="Transactions arrive in phase 4"
    body="Every transaction across every card, filterable and exportable. It needs statement data first — phase 2 brings the parsers that produce it."
  />
);

export const CashbackPage = () => (
  <Placeholder
    icon={Coins}
    title="The Real Cashback Ledger arrives in phase 5"
    body="Money that actually reduced a bill — never points, never pending offers. It's built on parsed statement credits, so the parsers come first."
  />
);

export const NotFoundPage = () => (
  <div className="mx-auto max-w-4xl">
    <Panel>
      <EmptyState
        title="No such page"
        body="That route doesn't exist in MyDeck."
        action={
          <Button asChild variant="default" size="sm">
            <Link to="/">Back to the dashboard</Link>
          </Button>
        }
      />
    </Panel>
  </div>
);
